import { render } from "./runningNumber.vue?vue&type=template&id=db12e246"
import script from "./runningNumber.vue?vue&type=script&lang=js"
export * from "./runningNumber.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__